import { Component, OnInit, ViewChild } from '@angular/core';
import { FirebaseService } from 'src/app/services/firebase.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFireStorage } from '@angular/fire/storage';
import { Router } from '@angular/router';


@Component({
  selector: 'app-allplans',
  templateUrl: './allplans.component.html',
  styleUrls: ['./allplans.component.css']
})


export class AllplansComponent implements OnInit {

  displayedColumns: string[] = ['pname','blank','speed','blank','data','blank','exspeed','blank', 'price','blank', 'category','blank', 'actions'];
  dataSource : MatTableDataSource<any[]>;


    
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private firebase: FirebaseService, private afs:AngularFireStorage, private router: Router) { 
    this.firebase.getPlans().subscribe( res => {
      this.dataSource=new MatTableDataSource<any>(res);
      this.dataSource.paginator = this.paginator;
    });
  }

  ngOnInit(): void {
  }

  goEdit(id){
    this.router.navigateByUrl('adminbackend/editplan/' + id);
  }

  goDelete(id){
    this.firebase.deletePlan(id);
  }

}
